import React from "react";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { userIsLoggedIn } from "../redux/auth/Action";
import { useDispatch } from "react-redux";
// import { allpost } from '../redux/auth/Action';
import { Link } from "react-router-dom";

const Navbar = () => {
  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  // const data = useSelector((e) => {
  //   return e.reducer;
  // });

  // function signoff() {
  //   localStorage.removeItem("cartoken");
  //   dispatch({
  //     type: "LOGOUT",
  //     payload: false,
  //   });
  //   navigate("/authentication");
  // }

  // useEffect(() => {
  //   if (data.token) {
  //     userIsLoggedIn(data.token, dispatch);
  //   }
  //   // if (data.token) {
  //   //   allpost(dispatch)
  //   // }
  //   if (!data.token) {
  //     navigate("/authentication");
  //   }
  // }, [data.token]);

  return (
    <>
      <div className="w-full bg-primary-500 h-16 flex px-8 justify-start items-center fixed top-0 z-50 shadow-md">
        <div className="flex items-center gap-3">
          <img
            src="./../../images/logo.png"
            className="w-9 h-9 object-contain"
            alt="Wam Bam Logo"
          />
          <Link to="/" className="text-xl font-bold text-white tracking-wide hover:text-primary-100 transition-colors duration-150">
            WAM BAM
          </Link>
        </div>
      </div>
    </>
  );
};

export default Navbar;
